<mat-toolbar class="fdb-toolbar bg-dark text-white">
  <div class="fdb-nav-left">
    <button mat-button class="fdb-nav-trigger" [matMenuTriggerFor]="projectsMenu" (menuOpened)="onMenuOpened('projects')">Projekte</button>
    <button mat-button class="fdb-nav-trigger" [matMenuTriggerFor]="reportsMenu" (menuOpened)="onMenuOpened('reports')">Reports</button>
    <button mat-button class="fdb-nav-trigger" [matMenuTriggerFor]="documentsMenu" (menuOpened)="onMenuOpened('documents')">Dokumente</button>
    @if (isAdmin) {
      <button mat-button class="fdb-nav-trigger" [matMenuTriggerFor]="adminMenu">Administration</button>
    }
  </div>

  <span class="fdb-spacer"></span>

  <div class="fdb-nav-right">
    <span class="fdb-status">
      {{ AppService.isProjectChange ? 'Änderungen vorhanden' : 'Projekt gespeichert' }}
      <i class="fas" [ngClass]="AppService.isProjectChange ? 'fa-exclamation-circle' : 'fa-check'"></i>
    </span>

    <button mat-button class="fdb-nav-trigger" [matMenuTriggerFor]="userMenu">
      <i class="fas fa-user"></i>
      {{ username }}
    </button>
  </div>
</mat-toolbar>

<mat-menu #projectsMenu="matMenu" [overlapTrigger]="false" yPosition="below" class="fdb-menu-panel fdb-menu-projects" panelClass="fdb-menu-panel fdb-menu-projects">
  <a mat-menu-item [routerLink]="routingPath.projectSearch" routerLinkActive="active">Projektübersicht</a>
  @if (hasRoles) {
    <a mat-menu-item [routerLink]="routingPath.projectNewMasterdata" routerLinkActive="active">Neues Projekt</a>
  }
</mat-menu>

<mat-menu #reportsMenu="matMenu" [overlapTrigger]="false" yPosition="below" class="fdb-menu-panel fdb-menu-reports" panelClass="fdb-menu-panel fdb-menu-reports">
  @if (isAdmin || isAdvisor || isApprover) {
    <button mat-menu-item type="button" (click)="downloadReportBlacklist()">Blacklist Report</button>
  }
  @if (isAdmin || isApprover) {
    <button mat-menu-item type="button" (click)="downloadReportManagementBlacklist()">Management Blacklist Report</button>
  }
  @if (isAdmin || isAdvisor || isApprover) {
    <button mat-menu-item type="button" (click)="downloadReportAlleProjekte()">Alle Projekte</button>
  }
  @if (isAdmin || isAdvisor || isApprover) {
    <button mat-menu-item type="button" (click)="downloadReportAlleProjekteExcel()">Alle Projekte exportieren</button>
  }
  <button mat-menu-item type="button" (click)="downloadReportMeineProjekte()">Meine Projekte</button>
  @if (appService.currentProjectId > 0) {
    <button mat-menu-item type="button" (click)="downloadReportAktuellesProjekt()">Aktuelles Projekt</button>
  }
</mat-menu>

<mat-menu #documentsMenu="matMenu" [overlapTrigger]="false" yPosition="below" class="fdb-menu-panel fdb-menu-documents" panelClass="fdb-menu-panel fdb-menu-documents">
  <a
    mat-menu-item
    href="https://teams.microsoft.com/_#/files/300_Projekte?threadId=19%3A1877691641814695bc913ce947b94d05%40thread.skype&ctx=channel&context=380_Projektdatenbank%252F381_NKV"
    target="_blank"
  rel="noopener noreferrer">Template NKV Datei</a>
</mat-menu>

<mat-menu #adminMenu="matMenu" [overlapTrigger]="false" yPosition="below" class="fdb-menu-panel" panelClass="fdb-menu-panel">
  <a mat-menu-item [routerLink]="routingPath.admin" routerLinkActive="active">Hilfslisten</a>
  <a mat-menu-item [routerLink]="routingPath.importInfo" routerLinkActive="active">Wichtige Informationen</a>
  <a mat-menu-item [routerLink]="routingPath.projectApproval + '/1'" routerLinkActive="active">Freigabe Test Seite</a>
</mat-menu>

<mat-menu #userMenu="matMenu" [overlapTrigger]="false" yPosition="below" panelClass="fdb-menu-panel">
  <button mat-menu-item type="button" (click)="logout()">Logout</button>
</mat-menu>
